<template>
  <div>monthlyRentals</div>
</template>
<script>
export default {
  name: 'MonthlyRentals',
}
</script>
